import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-[#d73b3e] font-medium' : 'text-gray-700 hover:text-[#d73b3e]';
  };
  const navItems = [{
    name: 'Home',
    path: '/',
    external: false
  }, {
    name: 'Developers',
    path: '/developers',
    external: false
  }, {
    name: 'Teams',
    path: 'https://www.certifiedlaravelcompany.com/',
    external: true
  }, {
    name: 'Jobs',
    path: '/jobs',
    external: false
  }, {
    name: 'Post a Job',
    path: '/post-job',
    external: false
  }];
  return <header className="sticky top-0 bg-white z-50 shadow-sm" data-id="element-101">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-between items-center py-4" data-id="element-103">
          <div className="flex items-center" data-id="element-104">
            <Link to="/" className="font-bold text-xl flex items-center" data-id="element-105">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nhDzN5rxc9j1eevXSaZqA8/Schermafbeelding_2025-09-23_185342.png" alt="CertifiedDevs Logo" className="h-12" data-id="element-106" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-107">
            {navItems.map(item => item.external ? <a key={item.path} href={item.path} className="text-gray-700 hover:text-[#d73b3e] text-sm font-medium transition-colors duration-200" target="_blank" rel="noopener noreferrer" data-id="element-108">
                  {item.name}
                </a> : <Link key={item.path} to={item.path} className={`${isActive(item.path)} text-sm transition-colors duration-200`} data-id="element-109">
                  {item.name}
                </Link>)}
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-110">
            <Link to="/login" className="text-sm font-medium text-gray-700 hover:text-[#d73b3e] px-4 py-2 rounded-full transition-colors duration-200" data-id="element-111">
              Login
            </Link>
            <Link to="/signup" className="text-sm font-medium text-white bg-[#d73b3e] px-6 py-2 rounded-full hover:bg-[#c02f32] transition-colors duration-200 shadow-sm" data-id="element-112">
              Sign Up
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-113">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-[#d73b3e] focus:outline-none" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-114">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-115" /> : <MenuIcon className="h-6 w-6" data-id="element-116" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden py-4" data-id="element-117">
            <div className="flex flex-col space-y-4" data-id="element-118">
              {navItems.map(item => item.external ? <a key={item.path} href={item.path} className="text-gray-700 hover:text-[#d73b3e] font-medium transition-colors duration-200" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} data-id="element-119">
                    {item.name}
                  </a> : <Link key={item.path} to={item.path} className={`${isActive(item.path)} transition-colors duration-200`} onClick={() => setIsMenuOpen(false)} data-id="element-120">
                    {item.name}
                  </Link>)}
              <div className="pt-4 border-t border-gray-200 flex flex-col space-y-4" data-id="element-121">
                <Link to="/login" className="font-medium text-gray-700 hover:text-[#d73b3e] transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-122">
                  Login
                </Link>
                <Link to="/signup" className="px-6 py-3 text-white bg-[#d73b3e] rounded-full font-medium hover:bg-[#c02f32] transition-colors duration-200 text-center shadow-sm" onClick={() => setIsMenuOpen(false)} data-id="element-123">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>}
      </div>
    </header>;
};